import {useStyles} from './AggregationControl.styles';
import {Aggregation} from "../../@types/Query";

const aggregations: Aggregation[] = [
    "minutes_1",
    "minutes_5",
    "hour",
    "day",
    "month",
];

const labels: {[key in Aggregation]: string} = {
    "minutes_1": "Minute",
    "minutes_5": "5 Min.",
    "hour": "Stunde",
    "day": "Tag",
    "month": "Monat",
    "year": "Jahr",
}

type Props = {
    label?: string
    value: Aggregation
    onChange: (value: Aggregation) => void
    className?: string
}

const AggregationControl = (
    {
        label = "Pro",
        value,
        onChange,
        className = ""
    }: Props
) => {
    const styles = useStyles();
    return (
        <div className={`${styles.component} ${className}`}>
            {label?.length > 0 ? <div className={styles.label}>{label}</div> : null}
            <div className={styles.options}>
            {aggregations.map(aggregation => {
                return (
                    <div
                        key={aggregation}
                        className={aggregation === value ? styles.selected : styles.button}
                        onClick={()=>onChange(aggregation)}
                    >
                        {labels[aggregation]}
                    </div>
                )
            })}
            </div>
        </div>
    )
}

export default AggregationControl